import { optionTitle_senderImage } from './SenderImageOption.locstring.json';
import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
var lazyQuickModule = new LazyModule(() => import('./lazyQuickOption'));
let SenderImageOption: LazyOption = createLazyOption(
    {
        key: 'senderImage',
        titleStringKey: optionTitle_senderImage,
        searchTermsStringKey: optionTitle_senderImage,
    },
    lazyFullModule,
    m => m.default,
    lazyQuickModule,
    m => m.default
);
export default SenderImageOption;
